import { css } from "@emotion/react";
import bgShadow from "../assets/shadow-bg.png";

export const styPadding = (val: string) => css`
  padding: ${val};
`;

export const styMargin = (val: string) => css`
  margin: ${val};
`;

export const styBold = css`
  font-weight: 700;
`;

export const stySectionTitle = css`
  font-family: "Bodoni Moda", serif;

  h1 {
    font-weight: 100;
    font-style: italic;
  }
`;

export const styCombineSections = css`
  text-align: center;
  color: #707e57;
  padding: 20px;
  background-color: #ffffff;
  background-image: url(${bgShadow});
  background-position: top left;
  background-repeat: no-repeat;
  background-size: cover;
  opacity: 1;

  button {
    font-size: 12px;
    font-weight: 500;
    fill: #ffffff;
    color: #ffffff;
    background-color: #a99d87;
    border-radius: 4px;
    padding: 8px 16px;
    width: fit-content;
    margin-top: 8px;
  }
`;
